import { searchParamsToQueryString } from '../utils/parsers';

function collectionReducer({
    apiCollectionName = 'collection',
    collectionActionName,
    defaultState,
    itemActionName,
    identifier = 'id',
    mapItem = (stateItem, newCollectionItem, newItem) => ({
        ...stateItem,
        ...newCollectionItem,
        ...newItem,
    }),
}) {
    const initialState = {
        collection: {},
        ids: [],
        initial: true,
        isLoading: false,
        items: {},
        queryIds: {},
        total: 0,
        ...defaultState,
    };

    return function reducer(state = initialState, action) {
        if (action.type === `${collectionActionName}_REQUEST`) {
            return {
                ...state,
                isLoading: true,
            };
        }

        if (action.type === `${collectionActionName}_SUCCESS`) {
            const collection = action.payload[apiCollectionName].reduce(
                (acc, item) => ({
                    ...acc,
                    [item[identifier]]: mapItem(state.collection[item[identifier]], item),
                }),
                {}
            );
            return {
                ...state,
                ...action.payload,
                actionParams: { ...action.actionParams },
                collection: { ...state.collection, ...collection },
                error: undefined,
                ids: action.payload[apiCollectionName].map(item => item[identifier]),
                initial: false,
                isLoading: false,
                queryIds: {
                    ...state.queryIds,
                    [searchParamsToQueryString(action.requestParams.params)]: action.payload[
                        apiCollectionName
                    ].map(item => item[identifier]),
                },
                requestSource: action.requestSource,
                ...(action.requestParams.params?.size < 2000 &&
                    !action.actionParams?.keepSearchQuery && {
                        searchQuery: searchParamsToQueryString(action.requestParams.params),
                    }),
            };
        }

        if (action.type === `${collectionActionName}_FAILURE`) {
            return {
                ...state,
                error: action.payload,
            };
        }

        if (action.type === `${itemActionName}_SUCCESS`) {
            const id = action.actionParams?.id ?? action.payload?.id;

            return {
                ...state,
                collection: {
                    ...state.collection,
                    [id]: {
                        ...mapItem(state.collection[id], undefined, action.payload),
                        error: undefined,
                    },
                },
                initial: false,
            };
        }

        if (action.type === `${collectionActionName}_ID_REPLACE`) {
            const { oldId, newId } = action.payload;

            return {
                ...state,
                // eslint-disable-next-line eqeqeq
                ids: state.ids.map(id => (id == oldId ? newId : id)),
            };
        }

        if (action.type === `${collectionActionName}_ID_PREPEND`) {
            const { id } = action.payload;

            return {
                ...state,
                ids: [id, ...state.ids],
            };
        }

        if (action.type === `DELETE_${itemActionName}_SUCCESS`) {
            const id = action.actionParams?.id;
            const newCollection = { ...state.collection };
            delete newCollection[id];
            // eslint-disable-next-line eqeqeq
            const newIds = state.ids.filter(item => item != id);
            return {
                ...state,
                collection: newCollection,
                ids: newIds,
                initial: false,
                total: newIds.length,
            };
        }

        if (action.type === `${itemActionName}_FAILURE` && action.actionParams?.id) {
            const id = action.actionParams?.id;

            return {
                ...state,
                collection: {
                    ...state.collection,
                    [id]: {
                        ...state.collection[id],
                        error: action.payload,
                    },
                },
                initial: false,
            };
        }

        if (action.type === `${collectionActionName}_EMPTY`) {
            return initialState;
        }

        return state;
    };
}

export default collectionReducer;
